import { DataAnalyticsTaggingErrorCode, DataAnalyticsTaggingEvent, DataAnalyticsTaggingEventType } from './data-analytics-tagging.domain';

export class DataAnalyticsTaggingConstants {
  static getOptanonWrapperContent (url: string): string {
    return (
      'var isFirst=true;' +
      'function OptanonWrapper() {' +
        'if (isFirst) {' +
          'var launch = document.createElement("script");' +
          'launch.setAttribute("async", "");' +
          'launch.setAttribute("src", "' + url + '");' +
          'document.head.appendChild(launch);' +
          'isFirst = false;' +
        '}' +
      '};'
    );
  }

  static dataInitializationScriptContent: string = 'window.tms_tag = window.tms_tag || [];';

  static defaultModalCloseEvent: DataAnalyticsTaggingEvent = {
    event: DataAnalyticsTaggingEventType.MODAL_CLOSE,
    page: { modalName: '' }
  }

  static getLinkClickEventData(name: string, type: string = 'link'): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.LINK_CLICK,
      link: {
        name,
        type
      }
    };
  }

  static getSearchEventData(term: string, results: string, type: string = 'tdw:search'): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.SEARCH,
      search: {
        term,
        results,
        type
      }
    };
  }

  static getVideoPageEventData(lessonType: string, section: string, title: string): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: lessonType,
        subSection1: 'learn',
        subSection2: lessonType,
        customPageName: `wb_learn-${lessonType}`,
        videoSection: section,
        mediaName: title,
        mediaType: 'video'
      }
    }
  }

  static getErrorPageEventData(errorMessage: string, modalName: string, pageName: string, errorCode: DataAnalyticsTaggingErrorCode = DataAnalyticsTaggingErrorCode.ERROR_500_CODE): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.ERROR,
      page: {
        modalName,
        subSection1: 'error',
        customPageName: pageName
      },
      error: {
        code: errorCode,
        message: errorMessage
      }
    };
  }
}
